/* eslint-disable import/prefer-default-export */
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
const { Form } = Styles;

export default Form;
